export default __webpack_public_path__ + "reactlogo.3ecb0cbc.jpg";